/* Production measurements, packed fit and cart submission rules for the new builder. */
(function (scope) {
  'use strict';

  const SHIPPING = { LETTER: 'Letter', LARGE_LETTER: 'Large Letter', TRACKED: 'Standard Tracked' };
  function fits(widthCm, heightCm, maxWidthCm, maxHeightCm) {
    if (![widthCm, heightCm].every(value => Number.isFinite(value) && value > 0)) return false;
    const tolerance = 1e-9;
    return (widthCm <= maxWidthCm + tolerance && heightCm <= maxHeightCm + tolerance) ||
      (heightCm <= maxWidthCm + tolerance && widthCm <= maxHeightCm + tolerance);
  }
  function shippingClass({ sizeLabel, productionWidthCm, productionHeightCm }) {
    if (/Banner$/i.test(String(sizeLabel))) return SHIPPING.TRACKED;
    if (fits(productionWidthCm, productionHeightCm, 23.5, 12)) return SHIPPING.LETTER;
    return fits(productionWidthCm, productionHeightCm, 26.5, 20.5) ? SHIPPING.LARGE_LETTER : SHIPPING.TRACKED;
  }
  function skuForBand(config, trial, size) {
    const prefix = config.skuPrefix || 'SS-SOC';
    const suffix = trial.group === 'Gloss' ? 'G' : 'S';
    const bandId = trial.route.bandId;
    const postalClass = shippingClass({
      sizeLabel: size.label,
      productionWidthCm: trial.shape.productionWidth,
      productionHeightCm: trial.shape.productionHeight,
    });
    let sku = `${prefix}-${bandId}-${suffix}`;
    if (postalClass === SHIPPING.TRACKED && ['B01', 'B02', 'B03'].includes(bandId)) sku = `${prefix}-${bandId}-TRACKED-${suffix}`;
    else if (postalClass === SHIPPING.LETTER && ['B03', 'B04'].includes(bandId)) sku = `${prefix}-${bandId}-LETTER-${suffix}`;
    else if (postalClass === SHIPPING.LARGE_LETTER && ['B01', 'B02'].includes(bandId)) sku = `${prefix}-LARGER-LETTER-${suffix}`;
    else if (postalClass === SHIPPING.LARGE_LETTER && ['B04', 'B05', 'B06', 'B36'].includes(bandId)) sku = `${prefix}-${bandId}-LARGE-LETTER-${suffix}`;
    if (trial.heading) sku = sku.replace(/-([GS])$/, '-H-$1');
    return sku;
  }
  function variantForBand(config, trial, size) {
    const sku = skuForBand(config, trial, size);
    // A missing or unavailable required postage variant must never fall back to a lighter one.
    return (config.product?.variants || []).find(variant => variant.sku === sku) || null;
  }
  function measurementProperties({ stickerWidthMm, stickerHeightMm, productionWidthMm, productionHeightMm }, pricingVersion = 'larger-minimum-v1') {
    return {
      '_Artwork Width Cm': String(stickerWidthMm / 10),
      '_Artwork Height Cm': String(stickerHeightMm / 10),
      '_Production Width Cm': String(productionWidthMm / 10),
      '_Production Height Cm': String(productionHeightMm / 10),
      '_Measurement Precision': 'full',
      '_Pricing version': pricingVersion,
    };
  }
  function decalSignature(line) {
    return JSON.stringify({ id: Number(line.variant_id || line.id), quantity: Number(line.quantity), properties: line.properties || {} });
  }
  function matchingCartLine(cart, requested) {
    const properties = requested.properties || {};
    return (cart?.items || []).some(line => Number(line.variant_id || line.id) === Number(requested.id) &&
      Number(line.quantity) >= Number(requested.quantity) &&
      Object.keys(line.properties || {}).length === Object.keys(properties).length &&
      Object.entries(properties).every(([key, value]) => String(line.properties?.[key]) === String(value)));
  }
  function checkoutItems(items, previousSignature, cart) {
    const [decal, ...addOns] = items;
    return previousSignature === decalSignature(decal) && matchingCartLine(cart, decal) ? addOns : items;
  }

  const API = { SHIPPING, fits, shippingClass, skuForBand, variantForBand, measurementProperties, decalSignature, matchingCartLine, checkoutItems };
  scope.SSStorefrontOrder = API;
  if (typeof module !== 'undefined' && module.exports) module.exports = API;
})(typeof window !== 'undefined' ? window : globalThis);
